import React,{useState, useEffect}  from 'react';
import Table from 'react-bootstrap/Table'
import { Helmet } from "react-helmet";
import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'




function Cshistory(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
      <Sides/>
      
<Helmet>
 
<title>Learn Free JavaScript History Tutorials For Beginners CodeExampler</title>
<meta name="description" content="Javascript History tutorial for beginners.CodeExampler provides javascript tutorial Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like Javascript tutorial, Javascript tutorial,Javascript tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,tutorial for begineers,Javascript history,javascript history,history of javascript,javascript Introduction" />
<link rel="canonical" href="https://www.codeexampler.com/javascript-history" />
</Helmet>

<div className='lg:pl-56'>
    <h1 className="m-4 mh1">Javascript History</h1>
    <div className="first">
       
    <a href="/javascript-dom-method">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        </div>
<p className="mt-4 para">
1, Javascript programming languages were designed by Brendan Eich<br/>
2, Javascript ECMAScript 1 (1997) or ES1 Version Release on 1997 is the first version or Edition of javascript<br/>
3, At Present use ES9 Version in javascript<br/>
4, JavaScript is primarily a client-side language, meaning it runs on your computer within your browser. 
</p>

    <Table  striped bordered hover responsive variant="dark" className="m-4">
  <thead>
    <tr>
      <th></th>
      <th colSpan="1">Javascript Versions</th>
      <th >Javascript Versions release date</th>
   
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Javascript Version ES1</td>
      <td>1997</td>
    </tr>
    <tr>
      <td>2</td>
      <td>Javascript Version ES2</td>
      <td>1998</td>
     
    </tr>
    <tr>
      <td>3</td>
      <td>Javascript Version ES3</td>
      <td>1999</td>
     
    </tr>
    <tr>
      <td>4</td>
      <td>Javascript Version ES4</td>
      <td>Rejected</td>
     
    </tr>

    <tr>
      <td>5</td>
      <td>Javascript Version ES5</td>
      <td>2009</td>
     
    </tr>

    <tr>
      <td>6</td>
      <td>Javascript Version ES6</td>
      <td>2015</td>
     
    </tr>

    <tr>
      <td>7</td>
      <td>Javascript Version ES7</td>
      <td>2016</td>
     
    </tr>


    <tr>
      <td>8</td>
      <td>Javascript Version ES8</td>
      <td>2017</td>
     
    </tr>

    <tr>
      <td>9</td>
      <td>Javascript Version ES9</td>
      <td>2018</td>
     
    </tr>


  </tbody>
</Table>



  <h1 className="mt-5">  </h1>
  <div className="back">
       
  <a href="/javascript-dom-method">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Cshistory;